var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Login_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 -1.90735e-06C5.37268 -1.90735e-06 -1.90735e-06 5.37268 -1.90735e-06 12C-1.90735e-06 18.6273 5.37268 24 12 24C18.6273 24 24 18.6273 24 12C24 5.37268 18.6273 -1.90735e-06 12 -1.90735e-06ZM18.3999 11.3264L11.9421 11.3264L13.1499 10.1183L12.1973 9.1658L9.83941 11.5237C9.57639 11.7867 9.57639 12.2133 9.83941 12.4763L12.1973 14.8342L13.1499 13.8817L11.9421 12.6736L18.3999 12.6736V11.3264ZM14.3579 18.0631C14.73 18.0631 15.0315 17.7616 15.0315 17.3895L15.0315 15.3683H13.6843V16.7159H6.94734L6.94734 7.28414L13.6843 7.28414V8.63165H15.0315V6.61053C15.0315 6.23842 14.73 5.93692 14.3579 5.93692L6.27373 5.93692C5.90162 5.93692 5.60011 6.23842 5.60011 6.61053L5.60011 17.3895C5.60011 17.7616 5.90162 18.0631 6.27373 18.0631H14.3579Z",
    fill: "#57E7C8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.e79203dbf07fa7d59b05546a94f9776f.svg";
export { ForwardRef as ReactComponent };